module.exports = __webpack_public_path__ + "static/img/banner5.ff251bb2.jpg";